var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 17,
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.8.8A1.1 1.1 0 0 0 .7 1.9v13.2a1.1 1.1 0 1 0 2.2 0V1.9A1.1 1.1 0 0 0 1.8.8Zm11.322 10.222a1.1 1.1 0 0 0 1.556 1.556l3.3-3.3a1.1 1.1 0 0 0 0-1.556l-3.3-3.3a1.1 1.1 0 1 0-1.556 1.556L14.545 7.4H6.2a1.1 1.1 0 0 0 0 2.2h8.345l-1.423 1.422Z"
})));
export default SvgLogout;